
import React, { useEffect } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { FormGroup, TextInput, NumericInput, TextArea, CurrencyInput, DropDown, InputGroup, DateInput } from '../../../../../../../../../components/form/form';
import { PATTERN_ALPHA_NUMERIC_SPACE, PATTERN_COUPON_RATES } from '../../../../../../../../../helpr/constants';


const CouponInfo = ({ securityFormState }) => {
  const { getTextFieldProps, getTextAreaProps, getField } = securityFormState;
  if( getField('couponType') === 'DISCOUNT' ) {
    return (
      <Row className="mt-1">
        <Col sm={6} lg={4}>
          <NumericInput inputProps={getTextFieldProps('couponDiscountRate')} decimalLimit={4} numberLimit={100} variant="default">
            Discount Rate (%):*
          </NumericInput>
        </Col>
      </Row>
    )
  }
  if( getField('couponType') === 'FIXED' ) {
    return (
      <>
        <Row className="mt-1">
          <Col sm={6} lg={4}>
            <NumericInput inputProps={getTextFieldProps('couponFixedInterestRate')} decimalLimit={4} numberLimit={100} variant="default">
              Coupon Interest Rate, % P.A.:*
            </NumericInput>
          </Col>
          <Col sm={6} lg={4}>
            <DateInput inputProps={getTextFieldProps('couponFixedRateSettingDate')}>
              Coupon Rate Setting Date:*
            </DateInput>
          </Col>
        </Row>
        <Row>
          <Col sm={6} lg={4}>
            <TextInput inputProps={getTextFieldProps('couponFixedRefRateUsed')} maxLength="75" pattern={PATTERN_COUPON_RATES}>
              Reference Rate Used:*
            </TextInput>
          </Col>
          <Col sm={6} lg={4}>
            <TextInput inputProps={getTextFieldProps('couponFixedSpreadOverRefRate')} maxLength="25" pattern={PATTERN_COUPON_RATES}>
              Spread over Reference Rate:*
            </TextInput>
          </Col>
        </Row>
      </>
    )
  }
  if( getField('couponType') === 'FLOATING' ) {
    return (
      <Row className="mt-1">
        <Col md="8">
          <TextArea inputProps={getTextAreaProps('couponFloatingRateBasis')} subtext="(indicate if information is otherwise included or contained in other documents submitted)" maxLength="250" pattern={PATTERN_ALPHA_NUMERIC_SPACE}>
            Basis for Determining Rate for Floating Rate Securities:*
          </TextArea>
        </Col>
      </Row>
    )
  }
  if( getField('couponType') === 'STEPPED' ) {
    return (
      <Row className="mt-1">
        <Col md="8">
          <TextArea inputProps={getTextAreaProps('couponSteppedProvisionDesc')} subtext="(indicate if information is otherwise included or contained in other documents submitted)" maxLength="250" pattern={PATTERN_ALPHA_NUMERIC_SPACE}>
            Description of Stepped Coupon Provision, if any:
          </TextArea>
        </Col>
      </Row>
    )
  }
  return (<div></div>)
}



export default CouponInfo;


